export default __webpack_public_path__ + "static/media/custom_api_bg.0d619d76.png";